import { instance } from '@/services/avik-api-gateway'
import { PenaltyAssessment } from '@/types/penalty-assessment'
import { AxiosResponse } from 'axios'

export function getEventPenaltyAssessment(
  eventUuid: string
): Promise<AxiosResponse<PenaltyAssessment>> {
  return instance.get(`/event/${eventUuid}/event-penalty-assessment`)
}
